import { useState } from 'react';
import { FaWhatsapp, FaLinkedinIn, FaEnvelope } from 'react-icons/fa';
import avatar2 from '../assets/avatar2.png';

const LeftPanel = () => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="w-full md:w-1/2 bg-orange-200 flex justify-center items-center p-8">
      <div className="bg-orange-100 p-6 shadow-xl rounded-md text-center max-w-xs w-full mx-auto md:ml-auto md:mr-[-4rem]">
        <div className="intro-avatar">
          {!loaded && <div className="intro-skeleton" />}

          <img
            src={avatar2}
            alt="Rita Neves"
            onLoad={() => setLoaded(true)}
            className={`rounded-full mx-auto mb-4 intro-item intro-image transition-opacity duration-700 ${
              loaded ? 'opacity-100' : 'opacity-0'
            }`}
          />
        </div>

        <h2 className="text-xl font-bold">Rita Neves</h2>
        <div className="text-sm tracking-widest text-gray-600 my-2">
          FRONTEND DEVELOPER
        </div>
        <div className="h-1 w-10 bg-teal-600 mx-auto mb-4" />

        <div className="flex justify-center gap-4 text-gray-700 mt-4">
          <a
            href="https://wa.me/+351911822530"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>
          <a
            href="https://www.linkedin.com/in/ritanevesalmeida"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="mailto:r_neves_almeida@hotmail.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Email"
          >
            <FaEnvelope />
          </a>
        </div>
      </div>
    </div>
  );
};

export default LeftPanel;
